module.exports = __webpack_public_path__ + "img/pdf.e06601fb.png";